import {SharedStatusPageFormDefaultValues} from "@/pages/statuspages/shared/StatusPageForm.utils.ts";
import {StatusPageDesignTabFormValues} from "@/pages/statuspages/tabs/design/StatusPageDesignTab.types.ts";
import {StatusPageGeneralFormValues} from "@/pages/statuspages/tabs/general/StatusPageGeneralTab.types.ts";
import {SubscribersSettingsFormValues} from "@/pages/statuspages/tabs/subscribers/components/SubscribersSettingsForm/SubscribersSettingsForm.types.ts";

export type SharedStatusPageFormData = StatusPageGeneralFormValues &
  StatusPageDesignTabFormValues &
  SubscribersSettingsFormValues;
export type SharedStatusPageFormKeys = keyof SharedStatusPageFormData;
export const SharedStatusPageFormKeys = Object.keys(
  SharedStatusPageFormDefaultValues
) as unknown as SharedStatusPageFormKeys;
